import React, { memo, useMemo, useState } from 'react';
import { Icon } from '../../../icon';
import { Menu } from '../../../menu';
import { AppBarButton } from '../../../app-bar-button';
import paginationHelper from './helpers';
import { PaginationWrapper, PaginationCounter, PaginationNavArrow, CounterButton, PaginationMenuItem } from './styled';
export const TablePagination = memo(({ pageSize, setPageSize, pageIndex, totalItems, canPreviousPage, canNextPage, nextPage, previousPage, pageSizeOptions = [10, 25, 50], ...rest }) => {
    const [isOpen, setOpen] = useState(false);
    const handleShowMenu = () => setOpen(!isOpen);
    const handleCloseMenu = () => setOpen(false);
    const paginationHelperArg = useMemo(() => ({ pageSize, pageIndex, totalItems }), [pageSize, pageIndex, totalItems]);
    return (React.createElement(PaginationWrapper, { ...rest },
        React.createElement(PaginationCounter, null,
            React.createElement(Menu, { isOpen: isOpen, position: "bottom-end", onClickOutside: handleCloseMenu, listComponent: "ul", content: React.createElement(React.Fragment, null, pageSizeOptions.map((item, index) => (React.createElement(PaginationMenuItem, { tabIndex: index, key: index, checked: item === pageSize, onClick: () => {
                        handleCloseMenu();
                        setPageSize(item);
                    } },
                    item,
                    item === pageSize && React.createElement(Icon, { name: "check", size: "small" }))))) },
                React.createElement(CounterButton, { variant: "text", text: paginationHelper(paginationHelperArg), onClick: handleShowMenu }))),
        React.createElement(PaginationNavArrow, { disabled: !canPreviousPage },
            React.createElement(AppBarButton, { title: "Previous", disabled: !canPreviousPage, onClick: previousPage },
                React.createElement(Icon, { key: "arrow_back", name: "arrow_back" }))),
        React.createElement(PaginationNavArrow, { disabled: !canNextPage },
            React.createElement(AppBarButton, { title: "Next", disabled: !canNextPage, onClick: nextPage },
                React.createElement(Icon, { key: "arrow_forward", name: "arrow_forward" })))));
});
